<template>
  <div>

    <!-- Filter Section -->
    <b-card title="Filters" class="mb-0">
      <b-form @submit.prevent>
        <b-row>
          <!-- Period -->
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('apps.reportSalesAging.singular.period')"
              label-for="period"
            >
              <v-select
                input-id="period"
                v-model="form.period"
                :options="LOV.period"
                :reduce="field => field.value"
                @input="handlePeriod"
              />
            </b-form-group>
          </b-col>

      <!-- Tagging -->
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('apps.reportSalesAging.singular.tags')"
              label-for="tags"
            >
              <v-select
                id="tas"
                label="name"
                v-model="form.tags"
                :options="LOV.tags"
                :reduce="field => field.value"
                :searchable="!actions.isPreview"
              />
            </b-form-group>
          </b-col>

          <!-- Until Start -->
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('apps.reportSalesAging.singular.dateUntil')"
              label-for="date-until"
            >
              <flat-pickr
                id="date-until"
                :config="dateFormat"
                v-model="form.dateUntil"
                class="form-control"
              />
            </b-form-group>
          </b-col>

          <!-- Contact -->
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('apps.reportSalesAging.singular.contact')"
              label-for="contact"
            >
              <v-select
                id="contacts"
                v-model="form.contactId"
                :options="LOV.contacts"
                :reduce="field => field.id"
                label="label"
                :disabled="actions.isPreview"
              />
            </b-form-group>
          </b-col>

          <!-- Button Filter -->
          <b-col cols="12" md="3">
            <b-button block variant="primary" @click="getReport" class="mt-2 pd-1">
              {{ $t('globalActions.find') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div class="mt-1 mb-1 d-flex justify-content-end">

      <b-button variant="outline-primary" @click="print">
        <feather-icon icon="FileIcon" />
        {{ $t('globalActions.print') }}
      </b-button>

      <b-button-group class="ml-1">
        <b-dropdown right variant="outline-primary">

          <template #button-content>
            <feather-icon icon="DownloadIcon"/>
            {{ $t('globalActions.export') }}
          </template>

          <b-dropdown-item-button @click="exportToPDF">PDF</b-dropdown-item-button>
          <b-dropdown-item-button @click="exportToExcel">Excel</b-dropdown-item-button>

        </b-dropdown>
      </b-button-group>

    </div>

    <!-- Table Container Card -->
    <b-card no-body id="pdfDom">

        <b-card-body class="text-center">
          <h2>{{ companyName }}</h2>
          <h3>{{ $t('apps.reportSalesAging.singular.salesAgingReport') }}</h3>
          <h4 class="mt-sm-1">{{ periodReportText }}</h4>
        </b-card-body>

        <b-table-simple id="balance-balance-table">
          <b-thead>
            <b-tr>
              <b-th v-for="column in tableColumns" :key="column.key" :class="column.thClass" >{{ column.label }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(prop) in itemLists" :key="prop.contact">
              <b-td class="text-right font-weight-bolder font-italic">
                <b-link
                :to="{ name: 'apps-report-sales-aging-detail', params: { id: prop.id }}"
                class="font-weight-bolder">
                <span class="font-weight-bolder d-block text-nowrap">
                {{ prop.contact_name }} </span>
                </b-link></b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.sum_of_bill_amount_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.outstanding_amount_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.top_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due15_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due30_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due60_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due90_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due120_view }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ prop.due121_view }}</b-td>
              <!-- <b-td v-for="column in tableColumns" :key="`${column.key}-${index}`" :class="column.tdClass">{{ prop[column.key] }}</b-td> -->
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td class="text-right font-weight-bolder font-italic">Total</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.sum_of_bill_amount }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.outstanding_amount }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.top }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due15 }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due30 }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due60 }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due90 }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due120 }}</b-td>
              <b-td class="text-right font-weight-bolder font-italic">{{ total.due121 }}</b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>

    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BCardBody,
  // BCardTitle,
  // BCardSubTitle,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BButtonGroup,
  BButton,
  BDropdown,
  BDropdownItemButton,
  // BTable,
  BTableSimple,
  BThead,
  BTh,
  BTr,
  BTd,
  BTbody,
  BTfoot,
  BLink
  // BLink
  // BSpinner
} from 'bootstrap-vue'

import { format, getMonth, endOfMonth, subMonths, addMonths, subYears, parse } from 'date-fns'
import { ref, onMounted, computed } from '@vue/composition-api'
import vSelect from 'vue-select'
import { formatCurrency } from '@/utils/formatter'
import flatPickr from 'vue-flatpickr-component'
import useListTable from '@/comp-functions/useListTable'

import useFormResource from '@/comp-functions/useFormResource'

export default {
  components: {
    BCard,
    BCardBody,
    // BCardTitle,
    // BCardSubTitle,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButtonGroup,
    BButton,
    BDropdown,
    BDropdownItemButton,
    // BTable,
    BTableSimple,
    BThead,
    BTh,
    BTr,
    BTd,
    BTbody,
    BTfoot,
    // BLink,
    // BSpinner,
    vSelect,
    flatPickr,
    BLink
  },
  computed: {
    companyName () {
      return this.$store.state.user.currentCompany.name
    }
  },
  setup () {
    const {
      routeParams,
      get,
      actions
    } = useFormResource({ url: 'report/sales-aging', localeContextPath: 'apps.reportSalesAging.singular.transaction', redirectPathName: 'apps-report-sales-aging' })

    const form = ref({
      contactId: '',
      tags: [],
      period: 'thisMonth',
      dateUntil: ''
    })
    const generatedUrl = (dateUntil = form.value.dateUntil,  contactId = form.value.contactId) => `reports/sales/aging?untilDate=${dateUntil}&contactId=${contactId}`
    
    const periodReportText = ref()

    // export format
    const formats = ['xlsx', 'csv', 'txt']

    const dateFormat = ref({ dateFormat: 'd/m/Y' })

    const typeIn = ['CI', 'BI']

    const { transactionTypeCode } = routeParams

    const LOV = ref({
      period: [
        { value: 'thisMonth', label: 'This Month' },
        { value: 'previousMonth', label: 'Previous Month' },
        { value: 'thisYear', label: 'This Year' },
        { value: 'previousYear', label: 'Previous Year' }
      ],
      contacts: [],
      tags: []
    })

    const getContacts = async () => {
      LOV.value.contacts = await get({ url: 'value/contact/customer'})
    }

    const getTags = async () => {
      LOV.value.tags = await get({ url: 'value/tag'})
    }

    // Table Handlers

    const tableColumns = [
      { key: 'contact_name', label: 'Customer', thClass:'', tdClass: '' },
      { key: 'sum_of_bill_amount_view', label: 'Bill Amount',  thClass:'text-right', tdClass: 'text-right' },
      { key: 'outstanding_amount_view', label: 'Outstanding' },
      { key: 'top_view', label: 'TOP' },
      { key: 'due15_view', label: '1-15' },
      { key: 'due30_view', label: '16-30' },
      { key: 'due60_view', label: '31-60' },
      { key: 'due90_view', label: '61-90' },
      { key: 'due120_view', label: '91-120' },
      { key: 'due121_view', label: '>120' }
    ]


    const handlePeriod = () => {
      const formatString = 'dd/MM/yyyy'
      const thisMonth = new Date()
      const whatMonth = getMonth(thisMonth) + 1
      const previousMonth = subMonths(thisMonth, 1)
      const lastMonthOfYear = addMonths(thisMonth, (whatMonth - 12) * -1)
      const lastMonthOfPreviousYear = subYears(lastMonthOfYear, 1)

      if (form.value.period === 'thisMonth') {
        form.value.dateUntil = format(endOfMonth(thisMonth), formatString)
      } else if (form.value.period === 'previousMonth') {
        form.value.dateUntil = format(endOfMonth(previousMonth), formatString)
      } else if (form.value.period === 'thisYear') {
        form.value.dateUntil = format(endOfMonth(lastMonthOfYear), formatString)
      } else {
        form.value.dateUntil = format(endOfMonth(lastMonthOfPreviousYear), formatString)
      }
    }

    const updatePeriodText = () => {
      const dateUntil = parse(form.value.dateUntil, 'dd/MM/yyyy', new Date())
      const formatUntilDate = format(dateUntil, 'd MMMM yyyy')
      periodReportText.value = `${formatUntilDate}`
    }

    const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists
    } = useListTable({ url: false })
    
    const total = computed(() => {
      const sum_of_bill_amount = formatCurrency(itemLists.value.reduce((accumulator, {sum_of_bill_amount}) => accumulator + sum_of_bill_amount, 0))
      const outstanding_amount = formatCurrency(itemLists.value.reduce((accumulator, {outstanding_amount}) => accumulator + outstanding_amount, 0))
      const top = formatCurrency(itemLists.value.reduce((accumulator, {top}) => accumulator + top, 0))
      const due15 = formatCurrency(itemLists.value.reduce((accumulator, {due15}) => accumulator + due15, 0))
      const due30 = formatCurrency(itemLists.value.reduce((accumulator, {due30}) => accumulator + due30, 0))
      const due60 = formatCurrency(itemLists.value.reduce((accumulator, {due60}) => accumulator + due60, 0))
      const due90 = formatCurrency(itemLists.value.reduce((accumulator, {due90}) => accumulator + due90, 0))
      const due120 = formatCurrency(itemLists.value.reduce((accumulator, {due120}) => accumulator + due120, 0))
      const due121 = formatCurrency(itemLists.value.reduce((accumulator, {due121}) => accumulator + due121, 0))
      return { sum_of_bill_amount, outstanding_amount, top, due15, due30, due60, due90, due120, due121 }
    })

    onMounted(async () => {
      handlePeriod()
      getContacts()
      getTags()
      await fetchLists(generatedUrl())
      updatePeriodText()
      if (transactionTypeCode) {
        form.value.transactionTypeCode = transactionTypeCode
      }
    })

    return {
      total,
      formatCurrency,
      generatedUrl,
      form,
      periodReportText,
      formats,
      LOV,
      dateFormat,
      tableColumns,
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists,
      handlePeriod,
      updatePeriodText,
      typeIn,
      transactionTypeCode,
      actions
    }
  },
  methods: {
    getReport () {
      console.log(this.form.contactId)
      this.fetchLists(`reports/sales/aging?untilDate=${this.form.dateUntil}&contactId=${this.form.contactId}`)
      this.updatePeriodText()
    },
    print () {
      window.print()
    },
    exportToPDF () {
      this.$nextTick(() => this.getPdf())
    },
    exportToExcel () {
      import('@/vendors/Export2Excel').then(excel => {
        const list = this.itemLists

        // add title
        // const title = [this.$store.state.user.currentCompany.name, this.$t('apps.reportLedger.singular.ledgerReport'), this.periodReportText]
        const headerTitle = this.tableColumns.map(column => column.label)
        // only take indexData from columnDef,
        const headerVal = this.tableColumns.map(column => column.key)
        const data = this.formatJson(headerVal, list)
        excel.export_json_to_excel({
          multiHeader: [
            [this.$store.state.user.currentCompany.name, '', '', '', '', '', ''],
            ['Sales Aging Report', '', '', '', '', '', ''],
            [this.periodReportText, '', '', '', '', '', ''],
            ['', '', '', '', '', '', '']
          ],
          header: headerTitle,
          data,
          merges: [
            { s: { c: 0, r: 0 }, e: { c: 6, r: 0 } },
            { s: { c: 0, r: 1 }, e: { c: 6, r: 1 } },
            { s: { c: 0, r: 2 }, e: { c: 6, r: 2 } },
            { s: { c: 0, r: 3 }, e: { c: 6, r: 3 } }
          ],
          filename: `Sales Aging Report ${this.periodReportText}`,
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .dropdown-menu .dropdown-item {
    width: 100%;
  }

  @media print {
    #app {
      * {
        visibility: hidden;
        margin: 0 !important;
      }

      #pdfDom,
      #pdfDom * {
        visibility: visible;
      }

      #pdfDom {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        margin-top: 100px;
      }
    }
  }

  @page {
    size: auto;
  }
</style>
